<script setup lang="ts">
import {onBeforeMount, ref} from "vue";
import {getTranslation, getSettings} from "@/ts/utilities.ts";

const settings = getSettings()

const props = defineProps({
	type: {
		type: Number,
	},
	splashTextColor: {
		type: String,
	},
	splashBackgroundColor: {
		type: String,
	},
	html: {
		type: String,
	},
})

let splashTranslations = ref()

splashTranslations.value = {
	translationSplashProductOffer: getTranslation('ProductOffer'),
	translationSplashNewItem: getTranslation('ProductNew'),
	translationSplashLowPrice: getTranslation('ProductLowPrice'),
	translationSplashDailyPrice: getTranslation('ProductDailyPriceSplash'),
	translationSplashCombinationOffer: getTranslation('ProductCombinationOffer'),
	translationSplashJubileePrice: getTranslation('ProductJubileePrice')
}


// Set splash class
let splashInfo = ref({
	class: '',
	text: '',
	textClass: ''
})
interface BlackFridayThemeObject {
	bgColor: string,
	textColor: string
}
const getBlackFridayTheme = (): BlackFridayThemeObject | null => {
	if (settings?.blackFridayTheme) {
		return {
			bgColor: 'bg-black text-white',
			textColor: 'text-white'
		}
	}
	return null;
}

const setSplash = () => {
	const bfTheme = getBlackFridayTheme();
	if (props.type == 1) {
		splashInfo.value = {
			class: bfTheme !== null ? bfTheme.bgColor : 'bg-yellow text-black',
			text: props?.html ?? splashTranslations.value.translationSplashProductOffer,
			textClass: bfTheme !== null ? bfTheme.textColor : 'text-black'
		}
	} else if (props.type == 2) {
		splashInfo.value = {
			class: bfTheme !== null ? bfTheme.bgColor : 'bg-primary text-white',
			text: splashTranslations.value.translationSplashNewItem,
			textClass: bfTheme !== null ? bfTheme.textColor : 'text-white'
		}
	} else if (props.type == 3) {
		splashInfo.value = {
			class: bfTheme !== null ? bfTheme.bgColor : 'bg-purple text-white',
			text: splashTranslations.value.translationSplashLowPrice,
			textClass: bfTheme !== null ? bfTheme.textColor : 'text-white'
		}
	} else if (props.type == 4) {
		splashInfo.value = {
			class: bfTheme !== null ? bfTheme.bgColor : 'bg-black text-yellow',
			text: splashTranslations.value.translationSplashDailyPrice,
			textClass: bfTheme !== null ? bfTheme.textColor : 'text-yellow'
		}
	} else if (props.type == 5) {
		splashInfo.value = {
			class: bfTheme !== null ? bfTheme.bgColor : 'bg-yellow text-black',
			text: splashTranslations.value.translationSplashCombinationOffer,
			textClass: bfTheme !== null ? bfTheme.textColor : 'text-black'
		}
	} else if (props.type == 6) {
		splashInfo.value = {
			class: bfTheme !== null ? bfTheme.bgColor : 'bg-brown text-white',
			text: splashTranslations.value.translationSplashJubileePrice,
			textClass: bfTheme !== null ? bfTheme.textColor : 'text-white'
		}
	}
}

onBeforeMount(() => {
	setSplash()
})

</script>

<template>
	<div
		class="flex items-center justify-center h-16 w-16 absolute top-4 right-4 p-4 rounded-full product-card-splash"
		:class="splashInfo.class"
		:style="props.splashBackgroundColor ? `background-color: ${props.splashBackgroundColor};` : ''"
	>
		<p class="m-0 uppercase text-xs font-bold leading-4 text-center" :class="splashInfo.textClass"
		   :style="props.splashTextColor ? `color: ${props.splashTextColor};` : ''"
		   v-html="splashInfo.text"
		>
		</p>
	</div>
</template>
